export default "https://embed.voomly.com/embed/macbook.ef8e6f3.png";